<template>
  <main>
    <section class="container mb-20">
      <h1 v-if="currentType" class="font-300 text-center mb-12">surco {{ currentType.name }}資料庫的品牌</h1>
      <input
        v-model="searchValue"
        type="text"
        class="border-b-2 focus:border-black focus:outline-none block w-full max-w-sm mx-auto text-24 py-2 leading-none font-300"
        placeholder="輸入關鍵字搜尋支援的品牌">
    </section>

    <slot name="spinner" />

    <section
      v-if="Object.keys(brandsGroupByInitial).length >= 1"
      class="container">
      <div
        v-for="(brands, initial) in brandsGroupByInitial"
        :key="initial"
        class="mb-20">
        <h1 class="text-20 bg-f5f5f5 w-12 h-12 flex items-center justify-center rounded-full mb-4">{{ initial }}</h1>
        <ul class="row list-reset pl-4">
          <li v-for="(brand, index) of brands" :key="index" class="col w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/6 mb-8">{{ brand }}</li>
        </ul>
      </div>
    </section>

    <section v-else-if="!isLoading && searchValue" class="mb-20">
      <h1 v-if="currentType" class="font-300 text-center text-on-light--lightest">沒有搜尋結果</h1>
    </section>

    <hr class="mt-0 mb-20">

    <section class="container">
      <h1 v-if="currentType" class="font-300 text-center mb-20">{{ currentType.name }}在app裡可以使用的功能鍵</h1>

      <div v-if="currentType.id === 'AC'" class="row justify-center">
        <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">主介面</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E5%86%B7%E6%B0%A3_-_%E4%B8%BB%E4%BB%8B%E9%9D%A2.jpg" alt="">
        </figure>
      </div>

      <div v-else-if="currentType.id === 'TV'" class="row justify-center">
        <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">主介面</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E9%9B%BB%E8%A6%96_-_%E4%B8%BB%E4%BB%8B%E9%9D%A2.jpg" alt="">
        </figure>
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">方向鍵等</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E9%9B%BB%E8%A6%96_-_%E6%96%B9%E5%90%91%E9%8D%B5%E7%AD%89.jpg" alt="">
        </figure> -->
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">數字鍵</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463794/surco-support/%E9%9B%BB%E8%A6%96_-_%E6%95%B8%E5%AD%97%E9%8D%B5.jpg" alt="">
        </figure> -->
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">常用頻道</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463794/surco-support/%E9%9B%BB%E8%A6%96_-_%E5%B8%B8%E7%94%A8%E9%A0%BB%E9%81%93.jpg" alt="">
        </figure> -->
      </div>

      <div v-else-if="currentType.id === 'set-top-box'" class="row justify-center">
        <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">主介面</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463794/surco-support/%E6%A9%9F%E4%B8%8A%E7%9B%92_-_%E4%B8%BB%E4%BB%8B%E9%9D%A2.jpg" alt="">
        </figure>
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">方向鍵等</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463794/surco-support/%E6%A9%9F%E4%B8%8A%E7%9B%92_-_%E6%96%B9%E5%90%91%E9%8D%B5%E7%AD%89.jpg" alt="">
        </figure> -->
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">數字鍵</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463794/surco-support/%E6%A9%9F%E4%B8%8A%E7%9B%92_-_%E6%95%B8%E5%AD%97%E9%8D%B5.jpg" alt="">
        </figure> -->
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">常用頻道</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463794/surco-support/%E6%A9%9F%E4%B8%8A%E7%9B%92_-_%E5%B8%B8%E7%94%A8%E9%A0%BB%E9%81%93.jpg" alt="">
        </figure> -->
      </div>

      <div v-else-if="currentType.id === 'DVD-player'" class="row justify-center">
        <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">主介面</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/DVD_-_%E4%B8%BB%E4%BB%8B%E9%9D%A2.jpg" alt="">
        </figure>
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">數字鍵</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/DVD_-_%E6%95%B8%E5%AD%97%E9%8D%B5.jpg" alt="">
        </figure> -->
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">其他功能</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/DVD_-_%E5%85%B6%E4%BB%96%E5%8A%9F%E8%83%BD.jpg" alt="">
        </figure> -->
      </div>

      <div v-else-if="currentType.id === 'audio-equipment'" class="row justify-center">
        <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">主介面</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E9%9F%B3%E9%9F%BF_-_%E4%B8%BB%E4%BB%8B%E9%9D%A2.jpg" alt="">
        </figure>
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">數字鍵</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E9%9F%B3%E9%9F%BF_-_%E6%95%B8%E5%AD%97%E9%8D%B5.jpg" alt="">
        </figure> -->
      </div>

      <div v-else-if="currentType.id === 'ceiling-light'" class="row justify-center">
        <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">主介面</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E5%90%B8%E9%A0%82%E7%87%88_-_%E4%B8%BB%E4%BB%8B%E9%9D%A2.jpg" alt="">
        </figure>
      </div>

      <div v-else-if="currentType.id === 'fan'" class="row justify-center">
        <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">主介面</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E9%A2%A8%E6%89%87_-_%E4%B8%BB%E4%BB%8B%E9%9D%A2.jpg" alt="">
        </figure>
      </div>

      <div v-else-if="currentType.id === 'robovac'" class="row justify-center">
        <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">主介面</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E6%8E%83%E5%9C%B0%E6%A9%9F%E5%99%A8%E4%BA%BA_-_%E4%B8%BB%E4%BB%8B%E9%9D%A2.jpg" alt="">
        </figure>
        <!-- <figure class="col w-full md:w-1/2 lg:w-1/4">
          <figcaption class="text-20 font-300 text-center mb-2">其他功能</figcaption>
          <img class="border-1" style="border-color: #e1e1e1" src="https://res.cloudinary.com/unipapa/image/upload/v1538463793/surco-support/%E6%8E%83%E5%9C%B0%E6%A9%9F%E5%99%A8%E4%BA%BA_-_%E5%85%B6%E4%BB%96%E5%8A%9F%E8%83%BD.jpg" alt="">
        </figure> -->
      </div>
    </section>
  </main>
</template>

<script>
import { ApplianceTypes } from "../constants";

export default {
  props: {
    brands: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      searchValue: "",
      ApplianceTypes
    };
  },

  computed: {
    currentType() {
      return (
        ApplianceTypes.find(type => type.id === this.$route.params.typeID) ||
        null
      );
    },

    brandsGroupByInitial() {
      const searchTerms = this.searchValue.match(/\S+/g);

      let predication;

      if (Array.isArray(searchTerms)) {
        const searchRegExp = new RegExp(searchTerms.join("|"), "i");
        predication = text => searchRegExp.test(text);
      } else {
        predication = () => false;
      }

      return Array.from(this.brands)
        .filter(predication)
        .sort()
        .reduce((groups, brand) => {
          const initial = brand[0].toUpperCase();
          if (Array.isArray(groups[initial])) {
            groups[initial].push(brand);
          } else {
            groups[initial] = [brand];
          }

          return groups;
        }, {});
    }
  }
};
</script>
